<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">设备管理</span>

    <div class="top_cp">
      <el-tag v-for="(item, index) in type_data" :key="index">
        {{ item.Type }}
        <span style="font-size:16px;">{{ item.Total }}</span>
      </el-tag>
    </div>

    <div class="box">
      <div>
        <el-button
          v-if="typeList == 'equipment'"
          size="mini"
          type="warning"
          @click="switch_repair('repair')"
        >
          切换到维修列表
        </el-button>
        <el-button
          v-else
          size="mini"
          plain
          type="warning"
          @click="switch_repair('equipment')"
        >
          切换到设备列表
        </el-button>
        <el-button size="mini" type="primary" @click="add_equipment">
          新增新购设备
        </el-button>
      </div>

      <div class="table_title" v-if="typeList == 'equipment'">
        - 设备列表 -
      </div>
      <div class="table_title" v-else>- 维修列表 -</div>
      <el-table
        :data="typeList == 'repair' ? repair_data : tableData"
        class="table"
        border
        stripe
      >
        <el-table-column
          type="index"
          label="#"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="Name"
          label="名称"
          min-width="150"
        ></el-table-column>
        <el-table-column prop="Type" label="类型" min-width="100">
        </el-table-column>
        <el-table-column
          prop="Pattern"
          label="型号"
          min-width="140"
        ></el-table-column>
        <el-table-column prop="Manufacturer" label="厂家" min-width="100">
        </el-table-column>
        <el-table-column prop="Price" label="价格" min-width="100">
        </el-table-column>
        <el-table-column prop="Number" label="数量" min-width="100">
        </el-table-column>
        <el-table-column prop="SerialNumber" label="序列号" min-width="200">
        </el-table-column>
        <el-table-column prop="PurchaseDate" label="购买日期" min-width="120">
        </el-table-column>
        <!-- <el-table-column prop="name" label="管理人"> </el-table-column> -->
        <el-table-column prop="Phone" label="状态" min-width="80">
          <template slot-scope="scope">
            <el-tag
              style="margin-right:6px;"
              size="mini"
              type="success"
              v-if="scope.row.Status == '正常'"
            >
              正常
            </el-tag>
            <el-tag
              style="margin-right:6px;"
              size="mini"
              type="warning"
              v-if="scope.row.Status == '维修'"
            >
              维修
            </el-tag>
            <el-tag
              style="margin-right:6px;"
              size="mini"
              type="danger"
              v-if="scope.row.Status == '损坏'"
            >
              损坏
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="User" label="管理人员"> </el-table-column>
        <el-table-column min-width="140" prop="School" label="校区">
        </el-table-column>
        <el-table-column prop="Remark" label="备注"> </el-table-column>
        <el-table-column label="操作" min-width="490">
          <template slot-scope="scope">
            <el-button
              v-if="userInfo.User.IsAdmin == true"
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="editCampus(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="warning"
              icon="el-icon-s-operation"
              size="mini"
              style="margin-left:12px;"
              @click="repair_button(scope.row.Id)"
            >
              报修
            </el-button>
            <el-button
              v-if="userInfo.User.IsAdmin == true"
              type="primary"
              icon="el-icon-position"
              size="mini"
              @click="distribution(scope.row.Id)"
            >
              分配校区
            </el-button>

            <el-popover placement="bottom" width="200" trigger="click">
              <div>
                <el-select
                  filterable
                  v-model="value_user"
                  placeholder="请选择用户"
                >
                  <el-option
                    v-for="item in options_user"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>

                <el-button
                  type="primary"
                  size="mini"
                  @click="user_is(scope.row.Id)"
                  style="float:right; margin-top:20px;"
                >
                  确定
                </el-button>
              </div>
              <el-button
                slot="reference"
                type="primary"
                icon="el-icon-position"
                size="mini"
                @click="administrator(scope.row.Id)"
                style="margin-left:8px;"
              >
                管理人
              </el-button>
            </el-popover>

            <el-button
              v-if="userInfo.Name == 'admin'"
              type="danger"
              icon="el-icon-delete"
              size="mini"
              style="margin-left:12px;"
              @click="delete_button(scope.row.Id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 校区分配弹框 -->
    <el-dialog
      title="校区分配"
      :close-on-click-modal="false"
      :visible.sync="distribution_dialog"
      width="40%"
    >
      <el-select v-model="value" placeholder="请选择校区">
        <el-option
          v-for="item in options"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="add_distribution_dialog" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 新增/修改设备弹框 -->
    <el-dialog
      :title="form.id ? '修改设备信息' : '新增设备'"
      :close-on-click-modal="false"
      :visible.sync="add_equipment_dialog"
      width="60%"
    >
      <el-form
        ref="form_ref"
        :model="form"
        :rules="rules"
        label-width="70px"
        class="login_from"
        label-position="right"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"> </el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-autocomplete
            value-key="Type"
            v-model="form.type"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择类型"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="型号" prop="pattern">
          <el-input v-model="form.pattern" placeholder="请输入型号"> </el-input>
        </el-form-item>
        <el-form-item label="厂家" prop="manufacturer">
          <el-input v-model="form.manufacturer" placeholder="请输入厂家">
          </el-input>
        </el-form-item>
        <el-form-item label="序列号" prop="serialNumber">
          <el-input v-model="form.serialNumber" placeholder="请输入序列号">
          </el-input>
        </el-form-item>
        <el-form-item label="日期" prop="purchaseDate">
          <el-date-picker
            v-model="form.purchaseDate"
            type="date"
            placeholder="选择日期"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="价格" prop="price" style="width:25%;">
          <el-input v-model="form.price" type="number" placeholder="价格">
          </el-input>
        </el-form-item>

        <el-form-item label="数量" prop="number" style="width:25%;">
          <el-input v-model="form.number" type="number" placeholder="数量">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" style="width:25%;">
          <el-input v-model="form.remark" placeholder="请输入备注"> </el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="正常">正常</el-radio>
            <el-radio label="维修">维修</el-radio>
            <el-radio label="损坏">损坏</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_equipment_dialog = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="add_equipment_determine" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 报修记录弹框 -->
    <el-dialog
      title="报修"
      :close-on-click-modal="false"
      :visible.sync="repair_dialog"
      width="60%"
    >
      <div>
        <el-date-picker
          style="width:30%"
          v-model="repairDate"
          type="date"
          placeholder="选择日期"
          value-format="timestamp"
        >
        </el-date-picker>
        <el-input
          style="width:30%;margin-left:12px;"
          v-model="price"
          placeholder="报修价格"
          type="number"
        ></el-input>

        <el-button
          type="primary"
          size="mini"
          @click="Price_is"
          style="margin-left:20px;"
        >
          报修
        </el-button>
      </div>
      <el-table :data="repair_data" class="table" border stripe>
        <el-table-column
          prop="RepairDate"
          label="日期"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="Price"
          label="维修价格"
          min-width="150"
        ></el-table-column>
        <el-table-column label="操作" min-width="200">
          <template slot-scope="scope">
            <el-button
              slot="reference"
              type="warning"
              icon="el-icon-edit"
              size="mini"
              style="margin-left:12px;"
              @click="edit_repair(scope.row)"
            >
              修改
            </el-button>
            <el-button
              style="margin-left:12px;"
              v-if="userInfo.Name == 'admin'"
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_repair(scope.row.Id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 修改报修弹框 -->
    <el-dialog
      title="修改报修记录"
      :close-on-click-modal="false"
      :visible.sync="repair_edit_dialog"
      @close="(repairDate = ''), (price = '')"
      width="40%"
    >
      <div>
        <el-date-picker
          style="width:30%"
          v-model="repairDate"
          type="date"
          placeholder="选择日期"
          value-format="timestamp"
        >
        </el-date-picker>
        <el-input
          style="width:30%;margin-left:12px;"
          v-model="price"
          placeholder="报修价格"
          type="number"
        ></el-input>

        <el-button
          type="primary"
          size="mini"
          @click="edit_repair_is()"
          style="margin-left:20px;"
        >
          修改
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import { getAllUser } from "@/api/user.js";
import { upload_resources_api } from "@/api/resources.js";
import { getSchool } from "@/api/admin.js";
import {
  get_asset_api,
  get_assetFilter_api,
  post_asset_api,
  put_asset_api,
  delete_asset_api,
  put_assetSchool_api,
  put_assetUser_api,
  get_asset_type_api,
  post_repair_api,
  get_repair_api,
  put_repair_api,
  delete_repair_api,
} from "@/api/asset.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    loading,
  },
  data() {
    return {
      rules: {
        // 名称
        name: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "",
          },
        ],
        // 类型
        type: [
          {
            required: true,
            message: "请输入类型",
            trigger: "change",
          },
        ],
        // 厂家
        manufacturer: [
          {
            required: true,
            message: "请输入厂家",
            trigger: "blur",
          },
        ],
        // 价格
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
        ],
        // 序列号
        serialNumber: [
          {
            required: true,
            message: "请输入序列号",
            trigger: "blur",
          },
        ],
        // 状态
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
        // 型号
        pattern: [
          {
            required: true,
            message: "请输入型号",
            trigger: "blur",
          },
        ],
        // 日期
        purchaseDate: [
          {
            required: true,
            message: "请输入日期",
            trigger: "blur",
          },
        ],
        // 数量
        number: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      distribution_dialog: false, // 用户分配弹框
      form: {
        name: "", //名称
        type: "", //类型
        number: "", //数量
        manufacturer: "", //厂家
        pattern: "", //型号
        price: "", //价格
        serialNumber: "", //序列号
        status: "正常", //状态
        purchaseDate: "", //日期
        remark: "", //备注
      },
      tableData: [],
      delete_form: [],
      uploadURL: "",
      options: [],
      user_query: {
        domain: {
          group: "SCHOOL",
          name: "",
        },
        subject: {
          group: "ROLE",
          name: "HEADMASTER",
        },
      },
      name: "",
      typeList: "equipment",
      add_equipment_dialog: false,
      role: false,
      value: "",
      distribution_id: "",
      administrator_id: "",
      options_user: [],
      value_user: "",
      repair_data: [],
      school_data: [],
      type_data: [],
      state: "",
      timeout: null,
      price: "",
      repair_data: [], //维修记录
      repair_dialog: false,
      repair_id: "",
      repairDate: "", //日期
      repair_edit_dialog: false,
      edit_id: "",
      loading_ok: "",
    };
  },

  watch: {
    //监听vuex数据，数据发生变化触发事件
    current() {
      this.school_data.forEach((vae) => {
        this.tableData = [];
        if (vae.Name == this.current) {
          get_assetFilter_api(vae.Id).then((res) => {
            res.data.forEach((v, i) => {
              v.PurchaseDate = this.filters.vdateAdd(v.PurchaseDate);

              this.school_data.forEach((s, n) => {
                if (v.SchoolId == s.Id) {
                  v.School = s.Name;
                }

                if (this.school_data.length == n + 1) {
                  this.tableData = res.data;
                }
              });
            });
          });
        }
      });
    },
  },

  created() {
    this.role = JSON.parse(sessionStorage.getItem("role"));
    console.log(this.role);
    //获取类型汇总
    get_asset_type_api().then((res) => {
      this.type_data = res.data;
    });

    if (this.userInfo.User.IsAdmin) {
      this.get_asset();
    } else {
      getSchool().then((value) => {
        this.school_data = value.data;

        value.data.forEach((vae) => {
          if (vae.Name == this.current) {
            localStorage.setItem("school_id", vae.Id);
            get_assetFilter_api(vae.Id).then((res) => {
              res.data.forEach((v, i) => {
                v.PurchaseDate = this.filters.vdateAdd(v.PurchaseDate);

                this.school_data.forEach((s, n) => {
                  if (v.SchoolId == s.Id) {
                    v.School = s.Name;
                  }

                  if (this.school_data.length == n + 1) {
                    this.tableData = res.data;
                    this.loading_ok = false;
                  }
                });
              });
            });
          }

          // if (value.data.length == n + 1) {
          //   this.tableData = res.data;
          // }
        });
      });
    }

    this.uploadURL = upload_resources_api();
    // if (sessionStorage.getItem("role")) {
    //   this.role = true;
    //   console.log(this.role);
    // }

    this.getAllUserFuntion();
  },

  methods: {
    querySearchAsync(queryString, cb) {
      var type_data = this.type_data;
      var results = queryString
        ? type_data.filter(this.createStateFilter(queryString))
        : type_data;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },

    createStateFilter(queryString) {
      return (state) => {
        return (
          state.Type.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

    //获取设备
    get_asset() {
      getSchool().then((value) => {
        this.options = value.data;
        this.school_data = value.data;
        get_asset_api().then((res) => {
          res.data.forEach((v, i) => {
            v.PurchaseDate = this.filters.vdateAdd(v.PurchaseDate);
            this.options.forEach((s, n) => {
              if (v.SchoolId == s.Id) {
                v.School = s.Name;
              }

              if (this.options.length == n + 1) {
                this.options_user.forEach((n, k) => {
                  if (n.Id == v.UserId) {
                    v.User = n.Name;
                  }
                  if (this.options.length == k + 1) {
                    this.tableData = res.data;
                    this.loading_ok = false;
                  }
                });
              }
            });
          });
        });
      });
    },

    //获取所有用户
    getAllUserFuntion() {
      getAllUser("", 0, 100000).then((res) => {
        this.options_user = res.data.Results;
      });
    },

    // 修改设备按钮
    editCampus(item) {
      this.form = {
        id: item.Id,
        name: item.Name,
        type: item.Type,
        number: item.Number,
        remark: item.Remark, //备注
        manufacturer: item.Manufacturer, //厂家
        pattern: item.Pattern, //型号
        price: item.Price, //价格
        serialNumber: item.SerialNumber, //序列号
        status: item.Status, //状态
        purchaseDate: Number(Date.parse(item.PurchaseDate)), //日期
      };

      this.add_equipment_dialog = true;
    },

    // 删除报修记录
    delete_repair(id) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_repair_api(id).then(() => {
            this.repair_dialog = false;
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    // 删除
    delete_button(id) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_asset_api(id).then(() => {
            this.get_asset();
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    // 分配
    distribution(id) {
      this.distribution_id = id;
      this.distribution_dialog = true;
    },

    // 分配用户确定
    add_distribution_dialog() {
      put_assetSchool_api(this.distribution_id, this.value).then(() => {
        this.get_asset();
        this.$message.success("成功！");
        this.distribution_dialog = false;
      });
    },

    //切换列表
    switch_repair(type) {
      this.typeList = type;
      this.repair_data = [];
      this.tableData.forEach((v) => {
        if (v.Status == "维修") {
          this.repair_data.push(v);
        }
      });
    },

    //新增新购设备
    add_equipment() {
      this.form = {
        name: "", //名称
        type: "",
        number: "", //数量
        remark: "", //备注
        manufacturer: "", //厂家
        pattern: "", //型号
        price: "", //价格
        serialNumber: "", //序列号
        status: "正常", //状态
        purchaseDate: "", //日期
      };
      this.add_equipment_dialog = true;
    },

    //新增新购设备确定按钮
    add_equipment_determine() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          this.form.purchaseDate = Number(
            this.form.purchaseDate.toString().slice(0, 10)
          );
          this.form.price = Number(this.form.price);
          this.form.number = Number(this.form.number);
          if (this.form.id) {
            delete this.form.Id;
            put_asset_api(this.form.id, this.form).then(() => {
              this.get_asset();
              this.$message.success("修改成功！");
              this.add_equipment_dialog = false;
            });
          } else {
            post_asset_api(this.form).then(() => {
              this.get_asset();
              this.$message.success("添加成功！");
              this.add_equipment_dialog = false;
            });
          }
        }
      });
    },

    //管理人
    administrator(id) {
      this.administrator_id = id;
    },

    user_is(id) {
      put_assetUser_api(id, this.value_user).then(() => {
        this.$message.success("分配成功！");
      });
    },

    Price_is() {
      if (!this.repairDate) {
        this.$message.error("日期不能为空！");
        return false;
      } else if (!this.price) {
        this.$message.error("金额不能为空！");
        return false;
      }
      post_repair_api({
        assetId: this.repair_id,
        price: Number(this.price),
        repairDate: Number(this.repairDate.toString().slice(0, 10)),
      }).then(() => {
        this.get_asset();
        this.repair_dialog = false;
        this.$message.success("报修成功！");
      });
    },

    repair_button(id) {
      this.repair_dialog = true;
      this.repair_id = id;
      this.repair_data = [];
      this.repairDate = "";
      this.price = "";
      get_repair_api(id).then((val) => {
        val.data.forEach((res, i) => {
          res.RepairDate = this.filters.vdateAdd(res.RepairDate);
          if (val.data.length == i + 1) {
            this.repair_data = val.data;
          }
        });
      });
    },

    repair_is(id, v) {
      (this.repairDate = Number(this.repairDate.toString().slice(0, 10))),
        put_repair_api(id, {
          assetId: this.repair_id,
          price: Number(this.price),
          repairDate: this.repairDate,
        }).then((res) => {
          this.repair_dialog = false;
          this.$message.success("修改成功！");
        });
    },

    edit_repair(item) {
      this.repairDate = Date.parse(item.RepairDate);
      this.price = item.Price;
      this.repair_edit_dialog = true;
      this.edit_id = item.Id;
    },

    edit_repair_is() {
      if (!this.repairDate) {
        this.$message.error("日期不能为空！");
        return false;
      } else if (!this.price) {
        this.$message.error("金额不能为空！");
        return false;
      }
      (this.repairDate = Number(this.repairDate.toString().slice(0, 10))),
        put_repair_api(this.edit_id, {
          assetId: this.repair_id,
          price: Number(this.price),
          repairDate: this.repairDate,
        }).then((res) => {
          this.repair_edit_dialog = false;
          this.repair_dialog = false;
          this.$message.success("修改成功！");
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .box {
        margin-top:30px;
        padding:16px;
    }
   .table {
     margin-top:20px;
   }
   .table_title {
     text-align: center;
     font-size: 24px;
     font-weight: 600;
     color:#666;
   }
   .elselect {
     margin-top:12px;
   }
   .elTagClass {
    margin-right:6px;
  }
}

.top_cp {
  margin-top:20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  padding:16px;
  .el-button {
    margin-bottom:12px;
  }
  .el-tag {
    margin-right:16px;
  }
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border:1px solid #eee;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-checkbox-group {
    margin-top:20px;
  }

  .el-select {
    margin-left:12px;
  }
</style>
